<script setup lang="ts">
import { ref } from 'vue';
import MoreVerticalDots from '@/assets/svg/dots-vertical-20.svg?component';
import SlashCircleIcon from '@/assets/svg/slash-circle.svg?component';

const props = defineProps<{
  isDoNotContact: boolean;
}>();

const emit = defineEmits<{
  (e: 'mark-do-not-contact'): void;
  (e: 'remove-do-not-contact'): void;
}>();

const isOpen = ref(false);

function onDoNotContactClick() {
  isOpen.value = false;
  if (props.isDoNotContact) {
    emit('remove-do-not-contact');
  } else {
    emit('mark-do-not-contact');
  }
}
</script>

<template>
  <v-menu v-model="isOpen" location="bottom end" transition="slide-y-transition">
    <template #activator="{ props: activatorProps }">
      <button
        v-bind="activatorProps"
        type="button"
        aria-label="More actions"
        data-test="pro-header-actions-menu"
        class="grid h-7 w-7 place-content-center rounded-md transition-colors hover:bg-tint-40"
        :class="{ 'bg-tint-40': isOpen }"
      >
        <MoreVerticalDots class="h-5 w-5 text-shade-900" />
      </button>
    </template>

    <div class="menu-card menu-card--sm mt-0.5">
      <button
        type="button"
        data-test="pro-header-action-do-not-contact"
        class="menu-item gap-2 whitespace-nowrap"
        @click="onDoNotContactClick"
      >
        <SlashCircleIcon
          v-if="!isDoNotContact"
          aria-hidden="true"
          class="h-5 w-5 shrink-0 text-shade-900"
        />
        {{ isDoNotContact ? 'Undo Do not contact' : 'Mark Do Not Contact' }}
      </button>
    </div>
  </v-menu>
</template>
